import React, { useEffect, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useHandlePreSign } from '../../hooks/useHandlePreSign';

interface FileType {
    [x: string]: any;
    thumbnail_s3_path?: string;
    s3_bucket_name?: string;
}

export const ThumbnailBox = ({ file, preView }: { file: FileType, preView?: boolean }) => {

    const [imgSrc, setImgSrc] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);

    const { handleGetThumbnail } = useHandlePreSign();

    useEffect(() => {
        const fetchThumbnail = async () => {
            if (!file.thumbnail_s3_path) {
                setLoading(false);
                return;
            }
            try {
                const params = {
                    content_type: file.type,
                    file_name: file.name,
                    key: file.thumbnail_s3_path,
                };
                const response = await handleGetThumbnail(params);
                setImgSrc(response);
            } catch (err) {
                console.error('Failed to fetch thumbnail:', err);
                setImgSrc(null);
            } finally {
                setLoading(false);
            }
        };
        fetchThumbnail();
    }, [file]);

    return (
        <Box
            sx={{
                width: '100%',
                height: '80%',
                position: 'relative',
                backgroundColor: '#f0f0f0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            {loading && (
                <CircularProgress
                    size={24}
                    sx={{ position: 'absolute' }}
                />
            )}
            {imgSrc && (
                <Box
                    component="img"
                    src={imgSrc}
                    alt="Thumbnail"
                    sx={{
                        width: preView ? '400px' : '100% ',
                        height: preView ? '400px' : '100%',
                        objectFit: 'cover',
                        display: loading ? 'none' : 'block',
                    }}
                />
            )}
        </Box>
    );
};